<template>
  <div class="container">
    <transition name="component-fade" mode="out-in">
      <keep-alive>
        <component v-bind:is="views"></component>
      </keep-alive>
    </transition>
    <!-- <div class="bottomTab_h"></div> -->
    <div class="bottomTab">
      <div
        class="bottomTab_item bottomTab_border"
        :class="{'tab_active':activeIndex==1}"
        @click="changeTab(1)"
      >历史邀请</div>
      <div class="bottomTab_item" :class="{'tab_active':activeIndex==0}" @click="changeTab(0)">历史拜访</div>
    </div>
  </div>
</template>

<script>
import yaoQing from "@/pages/fanke/history/yaoQing.vue";
import baiFang from "@/pages/fanke/history/baiFang.vue";
export default {
  name: "history",
  components: {
    yaoQing,
    baiFang
  },
  data() {
    return {
      views: "yaoQing",
      activeIndex: 0
    };
  },
  created() {
    this.activeIndex = this.$route.query.activeTab;
    if (this.activeIndex == 1) {
      this.views = "yaoQing";
    } else {
      this.views = "baiFang";
    }
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index;
      switch (index) {
        case 1:
          return this.views = "yaoQing";
        case 0:
          return this.views = "baiFang";
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  background: rgba(238, 238, 238, 1);
  height: 100vh;
  //
  .bottomTab_h {
    height: 108px;
  }
  .bottomTab {
    width: 100%;
    height: 108px;
    background: #ffffff;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    .bottomTab_item {
      flex: 1;
      text-align: center;
      line-height: 40px;
      font-size: 28px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
    .bottomTab_border {
      border-right: 1px solid rgba(234, 234, 234, 1);
    }
    .tab_active {
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
